<template>
  <img
    v-if="loaded"
    :src="imageSource"
    :alt="alt"
    :title="title"
    v-bind:key="imageSource"
    class="img-fluid"
    :width="365"
    :height="205"
    loading="lazy"
  />
  <img v-else :src="placeholder" :alt="alt" :title="title" />
</template>

<script>
export default {
  name: "LazyImage",
  props: {
    src: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: false,
      default: 365,
    },
    height: {
      type: Number,
      required: false,
      width: 205,
    },
    alt: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "poster",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    hasWebP() {
      return this.supportsWebP;
    },
    imageSource() {
      return this.hasWebP ? this.src + ".webp" : this.src;
    },
    placeholder() {
      if (this.type === "poster") {
        return this.hasWebP
          ? "/img/poster_placeholder.webp"
          : "/img/poster_placeholder.png";
      } else if (this.type === "horizontal") {
        return this.hasWebP
          ? "/img/horizontal_placeholder.webp"
          : "/img/horizontal_placeholder.png";
      }
      return "";
    },
  },
  data() {
    return {
      loaded: true,
    };
  },
  mounted() {
    // const img = new Image();
    // img.src = this.imageSource;
    // img.onload = () => {
    //   this.loaded = true;
    // };
  },
};
</script>

<style></style>
